import { render } from "./Avatar.vue?vue&type=template&id=009cf1dc&ts=true"
import script from "./Avatar.vue?vue&type=script&lang=ts"
export * from "./Avatar.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__